import { useState } from 'react';
import { Boxes, Grid3X3 } from 'lucide-react';
import ProjectFilesWorkspace from './ProjectFilesWorkspace';
import ProjectSetupSection, { CatalogueTabContent } from './ProjectSetupSection';
import MaterialthequeStatusCard from '../materialtheque/MaterialthequeStatusCard';
import TilesDialog from './siteplan/TilesDialog';

/** ProjectResourcesSection — V17.0 : Fichiers · Structures · Matériauthèque (catalogue fusionné + tuiles). */
export default function ProjectResourcesSection({ tab, projectId, navigate, pendingForBadge, filesProps, setupProps, styles, materials }) {
  const [tiles, setTiles] = useState(false);
  return (
    <div data-testid={`ressources-${tab}`}>
      {tab === 'fichiers' && <ProjectFilesWorkspace projectId={projectId} {...filesProps} />}
      {tab === 'structures' && <ProjectSetupSection {...setupProps} only="structure" />}
      {tab === 'materiautheque' && (
        <div className="space-y-5">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <p className="text-[12.5px] text-[var(--c-text-muted)]">Styles et matériaux du projet, références CCTP validées et tuiles de textures raccordables utilisées par la maquette texturée.</p>
            <div className="flex items-center gap-2">
              <button type="button" onClick={() => setTiles(true)} className="hud-btn hud-btn-secondary hud-btn-sm" data-testid="res-open-tiles"><Grid3X3 className="w-3.5 h-3.5" />Tuiles de textures</button>
              <button type="button" onClick={() => navigate(`/materialtheque?project=${projectId}`)} className="hud-btn hud-btn-primary hud-btn-sm relative" data-testid="res-open-materialtheque">
                <Boxes className="w-3.5 h-3.5" />Matériauthèque IA
                {pendingForBadge && <span aria-hidden className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-amber-400" />}
              </button>
            </div>
          </div>
          <MaterialthequeStatusCard projectId={projectId} />
          <CatalogueTabContent styles={styles} materials={materials} />
          {tiles && <TilesDialog projectId={projectId} onClose={() => setTiles(false)} onChanged={() => {}} />}
        </div>
      )}
    </div>
  );
}
